import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useAppContext } from '@prisjakt/ui-app-context';
import { PrimaryButton } from '@prisjakt/ui/button/variants';
import RouteContext from 'src/routes/context';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { priceShippingDisplay } from 'src/areas/product/actions/product';
import { PriceDisplayEnum } from 'src/components/price-list/types';
import {
  Wrapper,
  StyledContent,
  StyledIllustration,
  StyledTitle,
} from './styles';

const OfferListEmptyMessage = () => {
  const { market, t } = useAppContext();
  const { dispatch: routeDispatch } = useContext(RouteContext);
  const dispatch = useDispatch();
  const { clearAll } = useContext(PriceListFilterContext);

  const handleButtonClick = () => {
    dispatch(priceShippingDisplay(PriceDisplayEnum.PRICE));
    clearAll(routeDispatch);
  };

  return (
    <Wrapper>
      <StyledIllustration
        alt=""
        src={`${market.cdn}/g/rfe/illustrations/no-offers-illustration.png`}
        width={200}
        height={240}
      />
      <StyledContent>
        <StyledTitle>
          {t('product', 'price-list.no-matching-offers-in-filter')}
        </StyledTitle>
        <PrimaryButton onClick={handleButtonClick}>
          {t('filter', 'button.clear-filters')}
        </PrimaryButton>
      </StyledContent>
    </Wrapper>
  );
};

export default OfferListEmptyMessage;
